import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Icon} from '@drivesally/sally-ui';
import Tooltip from '@drivesally/sally-ui/lib/components/Tooltip/Tooltip';
import {darkGrey, grey} from '@drivesally/sally-ui/lib/libs/colors';

const Badge = styled.span`
  align-items: center;
  background: ${grey};
  border-radius: 10px;
  color: ${darkGrey};
  cursor: default;
  display: inline-flex;
  font-size: 11px;
  font-weight: 600;
  gap: 4px;
  line-height: 1;
  padding: 3px 7px;
  vertical-align: middle;
`;

const AgentList = styled.div`
  min-width: 160px;
`;

const AgentRow = styled.div`
  font-size: 12px;
  padding: 2px 0;
  white-space: nowrap;

  & + & {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
  }
`;

const CrmConnectedAgentsBadge = ({agents}) => {
  if (!agents?.length) return null;

  return (
    <Tooltip
      position="bottom"
      text={
        <AgentList>
          {agents.map((connection) => (
            <AgentRow key={connection.key}>{connection.agent}</AgentRow>
          ))}
        </AgentList>
      }
    >
      <Badge>
        <Icon icon="team" />
        {agents.length}
      </Badge>
    </Tooltip>
  );
};

CrmConnectedAgentsBadge.propTypes = {
  agents: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      agent: PropTypes.string,
      connectedAt: PropTypes.string,
    })
  ),
};

export default CrmConnectedAgentsBadge;
